import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpClientModule, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpParams, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { environment } from '../../environments/environment'

@Injectable({
  providedIn: 'root'
})
export class RestService {

  // Lets a page that knows the real institute being viewed (e.g. an academy-wide
  // member profile) push the correct faculty so <app-header> can re-sync its
  // name/logo/departments instead of relying on the hostname default.
  facultyContext = new BehaviorSubject<any>(null)

  constructor(public http :HttpClient) { }

  setFacultyContext(facultyId, FACULTY_NAME, branchId) {
    this.facultyId = facultyId
    this.FACULTY_NAME = FACULTY_NAME
    this.branchId = branchId
    this.facultyContext.next({ facultyId, FACULTY_NAME, branchId })
  }

  // https://api.aoa.edu.eg/api/

  GetBranchesFaculties(){
    return this.http.get(`${environment.baseUrl}api/InnovativeChild/GetBranchesFaculties`)
  }

  // home page
  homePage (){
    return this.http.get(`${environment.baseUrl}api/General/GetHomePage?NewsCount=8&eventsCount=4&ResearchesCount=4&GraduatesCount=30&ImagesCount=30`)
  }
  //  end home
  getbranch(){
    return this.http.get(`${environment.baseUrl}api/InnovativeChild/GetBranchesStructure`)
  }

  getGendar(){
    return this.http.get(`${environment.baseUrl}api/InnovativeChild/GetGender`)
  }

  getNationalities(){
    return this.http.get(`${environment.baseUrl}api/InnovativeChild/GetNationalities`)
  }

  GetAllowedPreCertificates(){
    return this.http.get(`${environment.baseUrl}api/General/GetAllowedPreCertificates`)
  }
  registerForm(value){
    let formData = new FormData()
    for (var i = 0; i < value.length; i++) {
      if(value[i].status){
        formData.append("text", JSON.stringify(value[i]));
      }else {
        formData.append("file[]", value[i]);
      }
    }
    formData.append("file", JSON.stringify(value));

    return this.http.post(`${environment.baseUrl}api/InnovativeChild/STUDENT_REGESTRATION`,formData)
  }


  // news 

  // facultyid filters the news server-side by institute. The API rejects an
  // empty value, so the "all institutes" case passes the literal `"` it expects.
  getNews(count, page, facultyid: any = '"'){
    const id = (facultyid === '' || facultyid === null || facultyid === undefined) ? '"' : facultyid
    return this.http.get(`${environment.baseUrl}api/General/GetNews?count=${count}&pageNumber=${page}&facultyid=${id}`)
  }
  newsDetails(id){
    return this.http.get(`${environment.baseUrl}api/General/GetNewsDetail?ID=${id}`)
  }

  // Construction (activity) news, filtered server-side by constructionid, paged.
  getConstructionNews(count, page, constructionid){
    return this.http.get(`${environment.baseUrl}api/General/GetNews?count=${count}&pageNumber=${page}&constructionid=${constructionid}`)
  }

  // events

  getEvents(){
    return this.http.get(`${environment.baseUrl}api/General/GetEvents?count=10&pageNumber=1`)
  }

  // Construction (activity) events, filtered server-side by constructionid, paged.
  getConstructionEvents(count, page, constructionid){
    return this.http.get(`${environment.baseUrl}api/General/GetEvents?count=${count}&pageNumber=${page}&constructionid=${constructionid}`)
  }
  eventDetails(id){
    return this.http.get(`${environment.baseUrl}api/General/GetEventDetails?id=${id}`)
  }

  // research 

  getResearch(){
    return this.http.get(`${environment.baseUrl}api/General/GetResearches?count=10&pageNumber=1`)
  }

  research_detail(id){
    return this.http.get(`${environment.baseUrl}api/General/GetResearchesDetails?id=${id}`)
  }

  GetConditionsAndTerms(){
    return this.http.get(`${environment.baseUrl}api/General/GetConditionsAndTerms`)

  }

  filesSupport(){
    return this.http.get(`${environment.baseUrl}api/General/GetApplicationFormsFiles`)

  }

  getConstrction(id){
    return this.http.get(`${environment.baseUrl}api/General/GetConstructionDetails?id=${id}`)
  }
  facultyId:any
  FACULTY_NAME:any
  branchId:any

  // Each academy activity/construction lives on its own subdomain
  // (<sub>.aoa.edu.eg) and is resolved to its construction id from the hostname,
  // exactly like the institutes are. Keyed by construction id.
  constructionSubdomains = {
    16: 'isc',   // المؤتمر العلمي الدولي
    19: 'dmu',   // مركز الإعلام الرقمي
    7:  'mofa',  // متحف الفنون الشعبية
    10: 'pnst',  // مسرح نهاد صليحة
    11: 'eqac',  // مركز ضمان جودة التعليم
    13: 'afts',  // المدرسة العربية للسينما والتليفزيون
    14: 'cam',   // مجلة الفن المعاصر
    15: 'apu',   // وحدة الإصدارات الأكاديمية
    9:  'soat',  // مدرسة أكاديمية الفنون للتكنولوجيا التطبيقية
    8:  'soa',   // مدرسة الفنون
    23: 'isadt'  // الإدارة العامة لنظم المعلومات والتحول الرقمي
  }

  // Returns the construction id mapped to the current hostname's subdomain
  // label (e.g. "isc" in isc.aoa.edu.eg) or null when the host isn't one of them.
  getConstructionIdByHost(){
    const label = String(window.location.hostname || '').split('.')[0].toLowerCase()
    const entry = Object.keys(this.constructionSubdomains)
      .find(id => this.constructionSubdomains[id] === label)
    return entry ? +entry : null
  }

  // Sends the user to a construction's own subdomain root (it resolves itself
  // from the hostname there), mirroring openFacultySite for institutes.
  openConstructionSite(item){
    const sub = item && this.constructionSubdomains[item.ID]
    if (sub) {
      window.location.href = 'https://' + sub + '.aoa.edu.eg/'
    }
  }

  // Each institute lives on its own subdomain (<sub>.aoa.edu.eg), same as the
  // constructions. Keyed by faculty id (matches the host→id map in
  // getFacultyIDAndName). The institute's own site resolves itself from the
  // hostname there. Returns true when a subdomain was found for the item.
  facultySubdomains = {
    8:  'himc',    // المعهد العالى لموسيقى الكونسرفاتوار
    11: 'hib',     // المعهد العالي للباليه
    12: 'hic',     // المعهد العالي للسينما
    13: 'hita',    // المعهد العالي للفنون المسرحية
    14: 'hiam',    // المعهد العالي للموسيقى العربية
    15: 'hifa',    // المعهد العالي للفنون الشعبية
    16: 'hiac',    // المعهد العالى للنقد الفنى
    17: 'hica',    // المعهد العالى لفنون الطفل
    19: 'hialamt'  // المعهد العالي لترجمات الفنون والآداب والوسائط الفنية
  }

  // Canonical display order for the institutes, by faculty id. Applied to every
  // list that shows them (home slider, top menu, footer) so they read the same
  // everywhere. Order (matches the names in facultySubdomains):
  //   13 المسرحية، 12 السينما، 8 الكونسرفاتوار، 14 الموسيقى العربية،
  //   11 الباليه، 16 النقد الفني، 15 الفنون الشعبية، 17 فنون الطفل،
  //   19 ترجمات الفنون والآداب والوسائط الفنية.
  facultyDisplayOrder = [13, 12, 8, 14, 11, 16, 15, 17, 19]

  // Returns a new array sorted into facultyDisplayOrder. Any id not listed keeps
  // its original API order after the known ones (stable via the index tiebreak).
  orderFaculties(arr){
    if (!Array.isArray(arr)) { return arr }
    const rank = (id) => {
      const i = this.facultyDisplayOrder.indexOf(+id)
      return i === -1 ? this.facultyDisplayOrder.length : i
    }
    return arr
      .map((item, idx) => ({ item, idx }))
      .sort((a, b) => (rank(a.item.ID) - rank(b.item.ID)) || (a.idx - b.idx))
      .map(x => x.item)
  }

  openFacultySite(item){
    const sub = item && this.facultySubdomains[item.ID]
    if (sub) {
      window.location.href = 'https://' + sub + '.aoa.edu.eg/'
      return true
    }
    return false
  }

  isAcademyHost(){
    const instituteHosts = [
      'himc.aoa.edu.eg','hib.aoa.edu.eg','hic.aoa.edu.eg','hita.aoa.edu.eg',
      'hiam.aoa.edu.eg','hifa.aoa.edu.eg','hiac.aoa.edu.eg','hica.aoa.edu.eg',
      'hialamt.aoa.edu.eg','hic-alx.aoa.edu.eg','hita-alx.aoa.edu.eg',
      'hiac-alx.aoa.edu.eg','hifa-alx.aoa.edu.eg'
    ];
    // A construction subdomain is not the academy host either.
    if (this.getConstructionIdByHost()) { return false }
    return !instituteHosts.includes(window.location.hostname);
  }
  getFacultyIDAndName(){
    let hostname = window.location.hostname
    if (hostname == 'himc.aoa.edu.eg') {
      this.facultyId = 8
      this.FACULTY_NAME = "المعهد العالى لموسيقى الكونسرفاتوار"
      this.branchId = 5
    } else if ( hostname == 'hib.aoa.edu.eg') {
      this.FACULTY_NAME = "المعهد العالي للباليه"
      this.facultyId = 11
      this.branchId = 5
    } else if (hostname == 'hic.aoa.edu.eg') {
      this.facultyId = 12
      this.FACULTY_NAME = "المعهد العالي للسينما"
      this.branchId = 5
    } else if (hostname == 'hita.aoa.edu.eg') {
      this.facultyId = 13
      this.FACULTY_NAME = "المعهد العالي للفنون المسرحية"
      this.branchId = 5
    } else if (hostname == 'hiam.aoa.edu.eg' ) {
      this.facultyId = 14
      this.FACULTY_NAME = "المعهد العالي للموسيقي العربيه"
      this.branchId = 5
    } else if (hostname == 'hifa.aoa.edu.eg') {
      this.facultyId = 15
      this.FACULTY_NAME = "المعهد العالي للفنون الشعبية"
      this.branchId = 5
    } else if (hostname == 'hiac.aoa.edu.eg') {
      this.facultyId = 16
      this.FACULTY_NAME = "المعهد العالى للنقد الفنى"
      this.branchId = 5
    } else if (hostname == 'hica.aoa.edu.eg') {
      this.FACULTY_NAME = "المعهد العالى لفنون الطفل "
      this.facultyId = 17
      this.branchId = 5
    } else if (hostname == 'hialamt.aoa.edu.eg') {
      this.FACULTY_NAME = "المعهد العالي لترجمات الفنون والآداب والوسائط الفنية"
      this.facultyId = 19
      this.branchId = 5
    }else if (hostname == 'hic-alx.aoa.edu.eg'){
      this.FACULTY_NAME = "المعهد العالي للسينما"
      this.facultyId = 12
      this.branchId = 6
    }else if (hostname == 'hita-alx.aoa.edu.eg'){
      this.facultyId = 13
      this.FACULTY_NAME = "المعهد العالي للفنون المسرحية"
      this.branchId = 6
    }else if (hostname == 'hiac-alx.aoa.edu.eg'){
      this.FACULTY_NAME = "المعهد العالى لفنون الطفل "
      this.facultyId = 16
      this.branchId = 6
    }else if (hostname == 'hifa-alx.aoa.edu.eg'){
      this.facultyId = 15
      this.FACULTY_NAME = "المعهد العالي للفنون الشعبية"
      this.branchId = 6
    }
    else {
      this.facultyId = 12
      this.FACULTY_NAME = "المعهد العالي للسينما"
      this.branchId = 5
    }

    return {
      facultyId : this.facultyId,
      FACULTY_NAME : this.FACULTY_NAME,
      branchId : this.branchId
    }
  }

}
